const vP18263 = require("./120.js");
const vP182632 = require("./303.js");
const vP182633 = require("./297.js");
const vP182634 = require("./121.js");
const vP182635 = require("./304.js");
const vLN7973 = 7973;
const v14046 = vP18263.getBCHDigit(vLN7973);
function f2173(p18264, p18265, p18266) {
  for (let vLN1175 = 1; vLN1175 <= 40; vLN1175++) {
    if (p18265 <= exports.getCapacity(vLN1175, p18266, p18264)) {
      return vLN1175;
    }
  }
}
function f2174(p18267, p18268) {
  return vP182634.getCharCountIndicator(p18267, p18268) + 4;
}
function f2175(p18269, p18270) {
  let vLN02591 = 0;
  p18269.forEach(function (p18271) {
    const vF2174 = f2174(p18271.mode, p18270);
    vLN02591 += vF2174 + p18271.getBitsLength();
  });
  return vLN02591;
}
function f2176(p18272, p18273) {
  for (let vLN1176 = 1; vLN1176 <= 40; vLN1176++) {
    const vF2175 = f2175(p18272, vLN1176);
    if (vF2175 <= exports.getCapacity(vLN1176, p18273, vP182634.MIXED)) {
      return vLN1176;
    }
  }
}
exports.from = function (p18274, p18275) {
  if (vP182635.isValid(p18274)) {
    return parseInt(p18274, 10);
  } else {
    return p18275;
  }
};
exports.getCapacity = function (p18276, p18277, p18278) {
  if (!vP182635.isValid(p18276)) {
    throw new Error("Invalid QR Code version");
  }
  if (typeof p18278 == "undefined") {
    p18278 = vP182634.BYTE;
  }
  const v14047 = vP18263.getSymbolTotalCodewords(p18276);
  const v14048 = vP182632.getTotalCodewordsCount(p18276, p18277);
  const v14049 = (v14047 - v14048) * 8;
  if (p18278 === vP182634.MIXED) {
    return v14049;
  }
  const v14050 = v14049 - f2174(p18278, p18276);
  switch (p18278) {
    case vP182634.NUMERIC:
      return Math.floor(v14050 / 10 * 3);
    case vP182634.ALPHANUMERIC:
      return Math.floor(v14050 / 11 * 2);
    case vP182634.KANJI:
      return Math.floor(v14050 / 13);
    case vP182634.BYTE:
    default:
      return Math.floor(v14050 / 8);
  }
};
exports.getBestVersionForData = function (p18279, p18280) {
  let v14051;
  const v14052 = vP182633.from(p18280, vP182633.M);
  if (Array.isArray(p18279)) {
    if (p18279.length > 1) {
      return f2176(p18279, v14052);
    }
    if (p18279.length === 0) {
      return 1;
    }
    v14051 = p18279[0];
  } else {
    v14051 = p18279;
  }
  return f2173(v14051.mode, v14051.getLength(), v14052);
};
exports.getEncodedBits = function (p18281) {
  if (!vP182635.isValid(p18281) || p18281 < 7) {
    throw new Error("Invalid QR Code version");
  }
  let v14053 = p18281 << 12;
  while (vP18263.getBCHDigit(v14053) - v14046 >= 0) {
    v14053 ^= vLN7973 << vP18263.getBCHDigit(v14053) - v14046;
  }
  return p18281 << 12 | v14053;
};